import { supabase } from 'pages/supabaseClient'
import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DataNotFound from 'components/NoData/dataNotFound';
import MDBox from 'components/MDBox';
import noDataImage from "assets/images/illustrations/noData3.svg";
import { UserDataContext } from 'context';
import MDButton from 'components/MDButton';
import dayjs from 'dayjs';
import axios from 'axios';
import EventsBookingTable from 'TailwindcssComponents/Tables/eventsBookingTable';

export default function EventsOnDate() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const { userData, selectedOrganization } = useContext(UserDataContext);
    const userRole = userData?.isAdmin ? 'admin' : selectedOrganization?.name || 'user';
    const orgId = selectedOrganization?.organization?.id || null;
    const [events, setEvents] = useState();
    const [venues, setVenues] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [bookedSeatsCount, setBookedSeatsCount] = useState({});
    const [totalSeatsCount, setTotalSeatsCount] = useState({});
    const navigate = useNavigate();
    const [totalItemsCount, setTotalItemsCount] = useState(0);
    const [totalPagesCount, setTotalPagesCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isArchived, setIsArchived] = useState(false);

    const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD

    const fetchEvents = async () => {
        if (userRole !== 'admin' && !orgId) return;
        setIsLoading(true);
        try {
            const [eventResponse, venueResponse] = await Promise.all([
                axios.get(`${apiUrl}event-service/event`, { params: { page: currentPage, limit: rowsPerPage, orgId: orgId, status: "published", startDate: currentDate, name: searchTerm } }),
                axios.get(`${apiUrl}event-service/event-venue`),
            ]);
            if (!eventResponse.data?.success || !eventResponse.data?.data) throw new Error('Failed to fetch events');
            if (!venueResponse.data?.success || !venueResponse.data?.data) throw new Error('Failed to fetch venues');

            const events = eventResponse?.data.data;
            const venues = venueResponse?.data.data;

            const enrichedEvents = events.map(event => ({
                ...event,
                venue: venues.find(venue => venue.id === event.venueId) || null
            }));
            setEvents(enrichedEvents);
            setFilteredEvents(enrichedEvents);
            setTotalItemsCount(eventResponse.data.totalItems || 0);
            setTotalPagesCount(eventResponse.data.totalPages || 0);
        } catch (error) {
            console.error(error.response?.data?.message || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, [currentPage, rowsPerPage, searchTerm, bearerToken]);

    // const fetchBookedSeatsCount = async (eventId) => {
    //     try {
    //         const { data, error } = await supabase
    //             .rpc('get_booked_event_seats_count', { event_id: eventId });
    //         if (data) {
    //             const bookedSeatsCount = data[0].booked_event_seats_count;
    //             setBookedSeatsCount(prevCounts => ({ ...prevCounts, [eventId]: bookedSeatsCount }));
    //         }
    //         if (error) {
    //             console.log(error);
    //             return 0;
    //         }
    //     } catch (error) {
    //         console.log('Error in fetching booked tickets', error);
    //         return 0;
    //     }
    // };

    // const fetchTotalSeatsCount = async (venueId) => {
    //     try {
    //         const { data, error } = await supabase
    //             .rpc('get_all_event_seats_count', { venue_id: venueId });
    //         if (data) {
    //             const totalSeatsCount = data[0].event_seats_count;
    //             setTotalSeatsCount(prevCounts => ({ ...prevCounts, [venueId]: totalSeatsCount }));
    //         }
    //         if (error) {
    //             console.log(error);
    //             return 0;
    //         }
    //     } catch (error) {
    //         console.log('Error in fetching seats count', error);
    //         return 0;
    //     }
    // };

    // useEffect(() => {
    //     events?.forEach(event => {
    //         fetchBookedSeatsCount(event.id);
    //         fetchTotalSeatsCount(event.venueId);
    //     });
    // }, [events]);


    const handleActionClick = (event) => {
        navigate(`/eventBookings/book-ticket/${event.id}`, {
            state: {
                eventName: event.name,
                venueName: event.venue_name,
                date: event.start,
                time: event.end,
                isFree: event.isFree,
                bookType: event.isSingleRegistrationPerTicket,
                purchaseLimit: event.ticketPurchaseLimit,
                orgId: event.orgId,
                bookedBy: 'admin',
            },
        });
    };

    const formatDateTime = (dateTime) =>
        `${new Date(dateTime).toLocaleDateString('en-CA')} ${new Date(dateTime).toLocaleTimeString('en-GB', { hour12: false })}`;

    const formattedDate = (date) => {
        return (new Date(date))
            .toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })
    };

    const filterEvents = (term) => {
        if (!term) {
            setFilteredEvents(events); // Reset to all data if search term is empty
            return;
        }
        const lowerCaseTerm = term.toLowerCase();
        const filtered = events.filter((event) =>
            event.name.toLowerCase().includes(lowerCaseTerm) // Filter by name
        );
        setFilteredEvents(filtered);
    };

    const handleSearch = (term) => {
        setSearchTerm(term);
        filterEvents(term);
    };

    return (
        <>
            {/* {events && events.length > 0 ? (
                <div className="p-4 shadow-md rounded-lg bg-white">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Event</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Venue</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Start Date</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">End Date</th>
                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {events.map((row) => {
                                    const bookedCount = bookedSeatsCount[row.id] || 0;
                                    const totalCount = totalSeatsCount[row.venueId] || 0;
                                    const isFull = (totalCount > 0) && (bookedCount >= totalCount);
                                    const venue_id = venues?.find((venue) => venue.id === row.venueId)?.id || 'N/A';
                                    const venue_name = venues?.find((venue) => venue.id === row.venueId)?.name || 'N/A';
                                    let is_Seat = venues?.find((venue) => venue.id === row.venueId)?.isSeat || false;

                                    return (
                                        <tr key={row.id}>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{row.name}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{venue_name}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formattedDate(row.eventDateTimes[0]?.date)}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formattedDate(row.eventDateTimes.at(-1)?.date)}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                <button
                                                    className={`px-4 py-2 rounded-md text-sm font-medium text-white
                                                                     ${isFull
                                                            ? 'bg-gray-400 cursor-not-allowed'
                                                            : 'bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
                                                        }`}
                                                    onClick={() => handleBookNowClick(row, venue_id, is_Seat)}
                                                    disabled={isFull}
                                                >
                                                    Book Now
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : (
                <DataNotFound message={'No Events Scheduled Yet !'} image={noDataImage} />
            )} */}

            <EventsBookingTable
                title={'Events Available For Booking'}
                rows={filteredEvents}
                onActionClick={handleActionClick}
                options={{ showHeader: true, showHeaderTwo: false, viewOption: true, editOption: true, addoption: false, statusFilterOption: false, dateFilterOption: false, typeFilterOption: false, searchOption: true, archiveFilterOption: true }}
                totalCount={totalItemsCount}
                pagesCount={totalPagesCount}
                currentPage={currentPage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(limit) => setRowsPerPage(limit)}
                onPageChange={(page) => setCurrentPage(page)}
                onSearch={handleSearch}
                searcItem={searchTerm}
                role={userRole}
                loaderStatus={isLoading}
                isArchivedStatus={isArchived}
                onToggle={(value) => setIsArchived(value)}
            />
        </>
    )
}

EventsOnDate.propTypes = {
    date: PropTypes.string.isRequired,
};
